export default function Pharmacy() {
  return null;
}
